/* cc-view-transition.js - 11 Oct 2026.
 * Shared-element page transition: the photograph you tap on a grid grows
 * into the photograph at the top of the product page, instead of the whole
 * page cross-fading.
 *
 * Cross-document view transitions are already switched on in cc-layout.css
 * (`@view-transition { navigation: auto }`), which gives a root cross-fade.
 * This adds the one thing that makes it read as a real transition rather
 * than a dissolve: ONE element that is the same object on both pages.
 *
 * How it has to work, and why it is this shape:
 *  - a view-transition-name must be UNIQUE in a document. A grid has 24
 *    cards, so the name cannot be in the Liquid; it is put on the clicked
 *    image only, at click time, and taken off again if the navigation is
 *    cancelled.
 *  - the browser snapshots the outgoing page when navigation STARTS, so
 *    setting the name in the click handler is early enough.
 *  - on the product page the name goes on whichever stage image is showing,
 *    which cc-pdp.js marks with .is-on.
 *
 * Everything here is progressive enhancement. A browser without view
 * transitions simply navigates, and nothing above is required for the page
 * to work. No scroll is intercepted and no listener is non-passive, which
 * the motion rules for this site require.
 */
(function () {
  if (!document.startViewTransition) return;              /* no support: plain nav */
  if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  /* 2026-10-12: the SAME name the quick preview uses, deliberately.
     cc-quick-view.js already puts 'cc-qv-active' on this exact element when
     it opens a preview, and clears it afterwards. Running a second name on
     the same element meant whichever script wrote last won and the other
     silently did nothing - which is why a transition name read back as
     empty on a card that had already been used to open a preview. One
     element, one name, and the two features stop fighting. It also makes
     the chain continuous: the same photograph is the shared object from
     grid to preview and from grid to product page. */
  var NAME = 'cc-qv-active';
  var clearTimer = null;

  function clearName() {
    var prev = document.querySelector('[style*="' + NAME + '"]');
    if (prev) prev.style.viewTransitionName = '';
  }

  /* --- leaving a grid: name the photograph that was tapped --- */
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a.cc-card[href*="/products/"]');
    if (!a) return;
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.button) return;  /* new tab: leave it alone */
    var img = a.querySelector('.cc-card__img');
    if (!img) return;
    clearName();
    img.style.viewTransitionName = NAME;
    /* If the navigation never happens - a blocked link, a cancelled load -
       the name must not be left behind, or the next transition on this page
       finds two elements with it and the browser skips the whole thing. */
    clearTimeout(clearTimer);
    clearTimer = setTimeout(clearName, 3000);
  }, { passive: true });

  /* --- arriving on a product page: name the showing stage image --- */
  function nameStage() {
    var stage = document.querySelector('.cc-pdp2__img.is-on')
             || document.querySelector('.cc-pdp2__img');
    if (stage) stage.style.viewTransitionName = NAME;
  }
  if (document.querySelector('.cc-pdp2__img')) {
    nameStage();
    /* cc-pdp.js moves .is-on as the gallery is used. Once the entry
       transition is over the name has to come off, or changing slide
       animates the name from one image to another on the same page. */
    window.addEventListener('pageshow', nameStage);
    setTimeout(function () {
      var s = document.querySelector('.cc-pdp2__img[style*="' + NAME + '"]');
      if (s) s.style.viewTransitionName = '';
    }, 700);
  }

  /* Going back to the grid, the card should be the shared element again. */
  window.addEventListener('pagehide', clearName);
})();
